// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const required = (value: any) => (value ? true : `This field is required`);

export default {
  required,
};
